import {useDev, useAxios, AxiosErrorDataModel} from '@sttedra_ui/framework';

/**
 * @typedef {import("@sttedra_ui/framework").AxiosErrorDataModel} AxiosErrorDataModel
 */

// #region Globals
const CONTEXT_BASE_PATH = 'CoordinateSystem';
const {base} = useAxios();
// #endregion


// #region Public functions
async function getCoordinatesSystem() {
  try {
    const url = `/${CONTEXT_BASE_PATH}`;

    const {data} = await base
      .get(url, {
        timeout: 5000,
      });

    return data;
  } catch (err) {
    return catchError(err);
  }
}

// #endregion


// #region Private functions
/**
 *
 * @param {AxiosErrorDataModel} errorModel
 * @returns
 */
function catchError(errorModel) {
  if (!(errorModel instanceof AxiosErrorDataModel)) {
    throw new Error(errorModel);
  }

  useDev.error(
    errorModel.errors
      .reduce((acc, e) => acc + `(${e.code}) ${e.type}: ${e.message}`,
        `[example.api] Errors:\n`),
  );
}
// #endregion

export {
  getCoordinatesSystem,
};
